import { Ad, AdCircuit, EditAd, EditAdCircuit, Stores } from "../types";
import { makeAutoObservable } from "mobx";
import api from "../services/api";

export class AdCircuitStore {
  stores: Stores;

  ads: Ad[] = [];
  adCircuits: AdCircuit[] = [];

  adCircuit: AdCircuit | undefined = undefined;

  isLoading = false;

  adCircuitsFilters: {
    [dataKey: string]: string | string[];
  } = {};

  constructor(stores: Stores) {
    this.stores = stores;

    makeAutoObservable(this);
  }

  getAdCircuits = async () => {
    this.isLoading = true;
    try {
      let adCircuits = await api.getAdCircuits();
      this.adCircuits = adCircuits;
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  getAdCircuitByID = async (id: string) => {
    this.isLoading = true;
    try {
      let adCircuit = await api.getAdCircuitByID(id);
      this.adCircuit = adCircuit;
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  addAdCircuit = async (data: EditAdCircuit) => {
    this.isLoading = true;
    try {
      let adCircuit = await api.addAdCircuit(data);
      this.adCircuits.unshift(adCircuit);
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  updateAdCircuit = async (data: EditAdCircuit) => {
    this.isLoading = true;
    try {
      await api.updateAdCircuit(data);
      this.getAdCircuitByID(String(data.id));
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  deleteAdCircuits = async (id: string) => {
    this.isLoading = true;
    try {
      await api.deleteAdCircuit(id);
      this.adCircuits = this.adCircuits.filter(
        (adCircuit) => adCircuit.id !== (id as unknown as number)
      );
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  getAds = async (id: string) => {
    this.isLoading = true;
    try {
      let ads = await api.getAds(id);
      this.ads = ads;
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  addAd = async (data: EditAd) => {
    this.isLoading = true;
    try {
      let ad = await api.addAd(data);
      this.ads.unshift(ad);
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  updateAd = async (data: EditAd) => {
    this.isLoading = true;
    try {
      let adUpdate = await api.updateAd(data);

      this.ads = this.ads.map((ad) => (ad.id === adUpdate.id ? adUpdate : ad));
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  deleteAd = async (id: string) => {
    this.isLoading = true;
    try {
      await api.deleteAd(id);
      this.ads = this.ads.filter((ad) => ad.id !== (id as unknown as number));
    } catch (err) {
      throw err;
    } finally {
      this.isLoading = false;
    }
  };
}
